import React, { useState, useEffect } from "react";
import {
  Paper,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  CircularProgress,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import api from "../../components/services/api";
// import DialogForAPI from "../../Component/DialogForAPI";

const drawerHeight = "100%";
const drawerwidth = "100%";
const useStyles = makeStyles((theme) => ({
  root: {
    height: drawerHeight,
    width: drawerwidth,
    marginTop: 20,
  },
  Padding: {
    paddingTop: "2%",
    paddingRight: "6%",
    paddingLeft: "6%",
    paddingBottom: "2%",
  },
  haft: { width: "45%" },
  row: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    padding: 8,
  },
  Margin: {
    marginTop: 10,
  },
}));

export default function Role() {
  const classes = useStyles();
  const EmpId = localStorage.getItem("EmpId");
  const [RoleList, setRoleList] = useState([]);
  const [openAdd, setOpenAdd] = useState(false);
  const [roleName, setRoleName] = useState("");
  // const [message, setmessage] = useState("");
  // const [open, setOpen] = useState(false);
  const [OpenEdit, setOpenEdit] = useState(false);
  const [RoleId, setRoleId] = useState("");
  const [openCancel, setOpenCancel] = useState(false);
  const [Loading, setLoading] = useState(false);

  // a little function to help us with reordering the result
  const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
  };

  const onDragEnd = (result) => {
    // dropped outside the list
    if (!result.destination) {
      return;
    }
    const items = reorder(
      RoleList,
      result.source.index,
      result.destination.index
    );

    setRoleList(items);
  };

  const fetchRoleList = async () => {
    try {
      const result = await api.get("api/role/list");
      const _result = result.data;
      setRoleList(_result);
    } catch (error) {
      console.log("error => ", error);
    }
  };

  const addRole = async () => {
    setLoading(true);
    if (roleName !== "") {
      const AddData = {
        roleName: roleName,
        level: RoleList.length + 1,
        createId: EmpId,
        status: 1,
      };

      // const body = { roleAll: [...RoleList, AddData] };

      try {
         await api
          .post("api/role/create", AddData)
          .then((res) => {
            if (res) {
              // setOpen(true);
              // setmessage(res.data.message);
              setTimeout(() => {
                handleClose();
                // setOpen(false);
              }, 500);
              fetchRoleList();
            }
          });
        // console.log(result);
      } catch (error) {
        console.log("error => ", error);
        setLoading(false);
      }
    } else {
      alert("กรุณากรอกชื่อตำแหน่งให้เรียบร้อย");
      setLoading(false);
    }
  };

  const EditRole = async () => {
    setLoading(true);
    const DelData = {
      id: RoleId,
      ModId: EmpId,
    };

    // const body = { roleAll: [...RoleList, AddData] };

    try {
      await api.post("api/role/delete", DelData).then((res) => {
        if (res) {
          setOpenCancel(true);
          // setmessage(res.data.message);
          setTimeout(() => {
            handleClose();
            setOpenCancel(false);
          }, 500);
          fetchRoleList();
        }
      });
      // console.log(result);
    } catch (error) {
      console.log("error => ", error);
      setLoading(false);
    }

    // setLoading(true);
    // const EditRole = RoleList.map((x, index) => ({
    //   role: x.RoleId,
    //   roleName: x.RoleName,
    //   // description: null,
    //   roleSta: x.roleSta,
    //   levels: index + 1,
    // }));

    // const body = { roleAll: EditRole };

    // try {
    //   const result = await api
    //     .post("api/setting/role/add", body)
    //     .then((res) => {
    //       if (res) {
    //         setOpen(true);
    //         setmessage(res.data.message);
    //         setTimeout(() => {
    //           handleClose();
    //           setOpen(false);
    //         }, 2000);
    //         fetchRoleList();
    //       }
    //     });
    // } catch (error) {
    //   console.log("error => ", error);
    //   setLoading(false);
    // }
  };

  useEffect(() => {
    fetchRoleList();
  }, []);

  const handleClose = () => {
    setOpenAdd(false);
    // setOpen(false);
    setOpenEdit(false);
    setRoleName("");
    setRoleId("");
    setOpenCancel(false);
    setLoading(false);
  };

  // const handleCloseDialog = (props) => {
  //   setOpen(props);
  // };

  const handleEditRole = (Role) => {
    setRoleName(Role.RoleName);
    setRoleId(Role.RoleId);
    setOpenEdit(true);
  };

  const handleSaveEdit = async () => {
    setLoading(true);
    const EditData = {
      id: RoleId,
      roleName: roleName,
      level: RoleList.length + 1,
      ModId: EmpId,
      status: 1,
    };

    // const body = { roleAll: [...RoleList, AddData] };

    try {
      await api.post("api/role/update", EditData).then((res) => {
        if (res) {
          setOpenEdit(true);
          // setmessage(res.data.message);
          setTimeout(() => {
            handleClose();
            setOpenEdit(false);
          }, 500);
          fetchRoleList();
        }
      });
      // console.log(result);
    } catch (error) {
      console.log("error => ", error);
      setLoading(false);
    }

    // const selectedRole = RoleList.filter((x) => x.RoleId === RoleId);

    // selectedRole.forEach((x) => {
    //   x.RoleName = roleName;
    // });

    // setRoleList([...RoleList]);

    // EditRole();
  };

  const handleCancle = (RoleSelect) => {
    setRoleName(RoleSelect.RoleName);
    setRoleId(RoleSelect.RoleId);
    setOpenCancel(true);
    // const cancelRole = RoleList.filter((x) => x.RoleId === RoleSelect.RoleId);

    // cancelRole.forEach((x) => {
    //   x.roleSta = "N";
    // });

    // setRoleList([...RoleList]);
  };

  return (
    <div className={classes.root}>
      <Paper elevation={1} style={{ height: "88vh", overflow: "auto" }}>
        <div className={classes.Padding}>
          <p style={{ color: "#80C340", fontSize: 18 }}>Sritrang-Admin</p>
          <h3>บทบาท</h3>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              flexDirection: "row",
              marginBottom: 30,
              position: "sticky",
              top: 10,
            }}
          >
            <Button
              variant="contained"
              size="large"
              style={{
                color: "#30318D",
                backgroundColor: "transparent",
                borderColor: "#30318D",
                width: 120,
                textTransform: "lowercase",
              }}
              onClick={() => setOpenAdd(true)}
            >
              เพิ่ม
            </Button>
            <Dialog
              open={openAdd}
              onClose={handleClose}
              fullWidth={true}
              maxWidth="xs"
              classes={{ paper: classes.dialogPaper }}
            >
              <DialogContent>
                <TextField
                  sx={{ width: "100%" }}
                  size="small"
                  onChange={(e) => setRoleName(e.target.value)}
                  value={roleName}
                  required
                  // error={ExcelNameErr}
                  label="ชื่อ"
                />
              </DialogContent>
              <DialogActions
                style={{
                  display: "flex",
                  justifyContent: "center",
                  marginBottom: 20,
                }}
              >
                <Button
                  variant="contained"
                  style={{
                    color: "black",
                    borderColor: "transparent",
                    backgroundColor: "#F8F9FA",
                    padding: 10,
                    marginRight: 10,
                    width: 80,
                  }}
                  onClick={handleClose}
                >
                  ยกเลิก
                </Button>
                <Button
                  variant="contained"
                  style={{
                    color: "white",
                    backgroundColor: "#80C340",
                    borderColor: "transparent",
                    padding: 10,
                    marginRight: 10,
                    width: 80,
                  }}
                  onClick={() => addRole()}
                >
                  ตกลง
                </Button>
              </DialogActions>
            </Dialog>
            {/* <Button
              variant="contained"
              size="large"
              style={{
                color: "white",
                backgroundColor: "#80C340",
                borderColor: "transparent",
                marginLeft: 10,
                width: 120,
                textTransform: "lowercase",
              }}
              onClick={() => EditRole()}
            >
              {Loading ? (
                <CircularProgress
                  sx={{
                    color: "#FFFFFF",
                  }}
                  size={24}
                />
              ) : (
                "บันทึก"
              )}
            </Button> */}
          </div>

          <DragDropContext onDragEnd={onDragEnd}>
            <Droppable droppableId="droppable">
              {(provided, snapshot) => (
                <div {...provided.droppableProps} ref={provided.innerRef}>
                  <div className={classes.row}>
                    <div className={classes.haft}>
                      <div sx={{ maxHeight: "58vh", height: "58vh" }}>
                        <table style={{ width: "100%" }}>
                          {RoleList.map((Data, index) => (
                            <Draggable
                              key={Data.RoleId}
                              draggableId={Data.RoleId}
                              index={index}
                            >
                              {(provided, snapshot) => (
                                <tr
                                  key={Data.RoleId}
                                  ref={provided.innerRef}
                                  {...provided.draggableProps}
                                  {...provided.dragHandleProps}
                                >
                                  <td
                                    style={{
                                      display: "flex",
                                      border: "1px solid #e0e0e0",
                                    }}
                                  >
                                    <span style={{ margin: "5px 0px 5px 5px" }}>
                                      {Data.RoleName}
                                    </span>
                                    <div
                                      style={{
                                        justifyContent: "flex-end",
                                        display: "flex",
                                        flexGrow: 1,
                                      }}
                                    >
                                      <button
                                        style={{
                                          border: 0,
                                          backgroundColor: "transparent",
                                        }}
                                      >
                                        <span
                                          className="material-icons"
                                          onClick={() => handleEditRole(Data)}
                                        >
                                          edit
                                        </span>
                                      </button>
                                      <button
                                        style={{
                                          border: 0,
                                          backgroundColor: "transparent",
                                        }}
                                      >
                                        <span
                                          className="material-icons-outlined"
                                          style={{ color: "#FF0000" }}
                                          onClick={() => handleCancle(Data)}
                                        >
                                          close
                                        </span>
                                      </button>
                                    </div>
                                  </td>
                                </tr>
                              )}
                            </Draggable>
                          ))}
                        </table>
                      </div>
                    </div>
                  </div>
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          </DragDropContext>

          <Dialog
            open={OpenEdit}
            onClose={handleClose}
            fullWidth={true}
            maxWidth="xs"
            classes={{ paper: classes.dialogPaper }}
          >
            <DialogContent>
              <TextField
                sx={{ width: "100%" }}
                size="small"
                onChange={(e) => setRoleName(e.target.value)}
                value={roleName}
                required
                // error={ExcelNameErr}
                label="ชื่อ"
              />
            </DialogContent>
            <DialogActions
              style={{
                display: "flex",
                justifyContent: "center",
                marginBottom: 20,
              }}
            >
              <Button
                variant="contained"
                style={{
                  color: "black",
                  borderColor: "transparent",
                  backgroundColor: "#F8F9FA",
                  padding: 10,
                  marginRight: 10,
                  width: 80,
                }}
                onClick={handleClose}
              >
                ยกเลิก
              </Button>
              <Button
                variant="contained"
                style={{
                  color: "white",
                  backgroundColor: "#80C340",
                  borderColor: "transparent",
                  padding: 10,
                  marginRight: 10,
                  width: 80,
                }}
                onClick={() => handleSaveEdit()}
              >
                {Loading ? (
                  <CircularProgress
                    sx={{
                      color: "#FFFFFF",
                    }}
                    size={24}
                  />
                ) : (
                  "ตกลง"
                )}
              </Button>
            </DialogActions>
          </Dialog>

          <Dialog
            open={openCancel}
            onClose={handleClose}
            fullWidth={true}
            maxWidth="xs"
            classes={{ paper: classes.dialogPaper }}
          >
            <DialogTitle>ยืนยันที่จะลบหรือไม่</DialogTitle>
            <DialogActions
              style={{
                display: "flex",
                justifyContent: "center",
                marginBottom: 20,
              }}
            >
              <Button
                variant="contained"
                style={{
                  color: "black",
                  borderColor: "transparent",
                  backgroundColor: "#F8F9FA",
                  padding: 10,
                  marginRight: 10,
                  width: 80,
                }}
                onClick={handleClose}
              >
                ยกเลิก
              </Button>
              <Button
                variant="contained"
                style={{
                  color: "white",
                  backgroundColor: "#FF0000",
                  borderColor: "transparent",
                  padding: 10,
                  marginRight: 10,
                  width: 80,
                }}
                onClick={() => EditRole()}
              >
                {Loading ? (
                  <CircularProgress
                    sx={{
                      color: "#FFFFFF",
                    }}
                    size={24}
                  />
                ) : (
                  "ตกลง"
                )}
              </Button>
            </DialogActions>
          </Dialog>

          {/* <DialogForAPI
            DialogOpen={open}
            DialogClose={handleCloseDialog}
            message={message}
          /> */}
        </div>
      </Paper>
    </div>
  );
}
